import useDemoHelper from "./useDemoHelper";
import step41 from "../../../../../assets/demo/emergency/4.1.mp3";
import step42 from "../../../../../assets/demo/emergency/4.2.mp3";
import step43 from "../../../../../assets/demo/emergency/4.3.mp3";
import step44 from "../../../../../assets/demo/emergency/4.4.mp3";
import step45 from "../../../../../assets/demo/emergency/4.5.mp3";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const flashStandardizedItemSelector = () => {
        demoHelper.flash('[data-test="input-standardized-item"]', 7);
    }

    const clickToMainWork = async visual => {
        demoHelper.flash('[data-test="button-add-main-work"]', 2);

        await demoHelper.sleep(3000);

        if (!visual) {
            return;
        }

        demoHelper.click('[data-test="button-add-main-work"]');
    }

    const flashUpdateItem = async visual => {
        if (!visual) {
            await demoHelper.sleep(7500);
            return;
        }

        demoHelper.flash('[data-test="quotation-item-option"]', 3);

        await demoHelper.sleep(3000);

        demoHelper.click('[data-test="quotation-item-option"]');

        await demoHelper.sleep(500);

        demoHelper.flash('[data-test="quotation-item-option-update"]', 2);

        await demoHelper.sleep(2000);

        demoHelper.flash('[data-test="quotation-item-option-delete"]', 2);

        await demoHelper.sleep(2000);

        document.getElementsByClassName('MuiModal-backdrop')[1].click();
    }

    const flashSecondAppointment = () => {
        const element = document.querySelector('[data-test="skeleton-body"]');
        element.scrollTop = element.scrollHeight

        demoHelper.flash('[data-test="input-second-appointment"]', 2);
    }

    const flashClientPhoneInput = () => {
        demoHelper.flash('[data-test="input-client-phone"]', 1);
    }

    const flashClientEmailInput = () => {
        demoHelper.flash('[data-test="input-client-email"]', 1);
    }

    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 22 seconds
            window.sound.src = step41;
            window.sound.play();


            await demoHelper.sleep(4000);
            flashStandardizedItemSelector();

            await demoHelper.sleep(19000);

            // 16 seconds
            window.sound.src = step42;
            window.sound.play();


            await demoHelper.sleep(8000);

            await clickToMainWork(visual);

            await demoHelper.sleep(5000);

            // 4 seconds
            window.sound.src = step43;
            window.sound.play();


            await flashUpdateItem(visual);

            // 12 seconds
            window.sound.src = step44;
            window.sound.play();

            await demoHelper.sleep(4000);

            flashSecondAppointment();

            await demoHelper.sleep(4000);

            flashClientPhoneInput();

            await demoHelper.sleep(2000);

            flashClientEmailInput();

            await demoHelper.sleep(3000);

            // 2 seconds
            window.sound.src = step45;
            window.sound.play();

            demoHelper.unlockInteract();
        }
    }
}